// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the list */
.admin-tx-list-container {
    background: white;
    padding: 1.5rem;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    min-height: 400px;
}

/* Container for the right side of the transfer card */
.admin-tx-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.6rem;
    flex-shrink: 0;
    margin-left: 1rem;
}

/* The Amount */
.admin-tx-amount {
    margin: 0;
    font-size: 1.4rem;
    font-weight: 800;
    line-height: 1;
}

/* Button Wrapper */
.admin-tx-actions {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

/* Sleeker Action Buttons for the Card */
.admin-tx-btn {
    display: flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.5rem 0.85rem;
    border-radius: 8px;
    font-weight: 700;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid transparent;
}

.btn-reject-tx {
    background: #fef2f2;
    color: #dc2626;
    border-color: #fecaca;
}

.btn-reject-tx:hover {
    background: #fee2e2;
    border-color: #ef4444;
}

.btn-confirm-tx {
    background: #ecfdf5;
    color: #059669;
    border-color: #a7f3d0;
}

.btn-confirm-tx:hover {
    background: #d1fae5;
    border-color: #10b981;
}

/* === NEW: TABS UI === */
.wallet-controls {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: white;
    padding: 1rem;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
    border: 1px solid #e2e8f0;
    margin-bottom: 2rem;
}

.wallet-tabs {
    display: flex;
    gap: 0.5rem;
}

.w-tab {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: transparent;
    border: none;
    color: #64748b;
    padding: 0.75rem 1.25rem;
    border-radius: 8px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: 0.2s;
}

.w-tab:hover {
    background: #f1f5f9;
    color: #1e293b;
}

.w-tab.active {
    background: #1e293b;
    color: white;
}

/* === NEW: HISTORY STATUS BADGES === */
.w-status {
    font-size: 0.75rem;
    font-weight: 700;
    padding: 0.25rem 0.65rem;
    border-radius: 6px;
    text-transform: uppercase;
    display: inline-block;
    margin-top: 0.25rem;
}

.s-green {
    background: #dcfce7;
    color: #15803d;
}

.s-red {
    background: #fee2e2;
    color: #b91c1c;
}

.s-gray {
    background: #f1f5f9;
    color: #64748b;
}

.s-yellow {
    background: #fef9c3;
    color: #b45309;
}

.bg-blue-light {
    background: #eff6ff;
}

.text-blue {
    color: #2563eb;
}

/* Responsive Overrides */
@media (max-width: 768px) {

    /* Stack the entire card on mobile */
    .admin-employees-container .elder-list-card {
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
    }

    .admin-tx-right {
        margin-left: 0;
        align-items: stretch;
        border-top: 1px solid #f1f5f9;
        padding-top: 1rem;
    }

    .admin-tx-amount {
        text-align: left;
        margin-bottom: 0.5rem;
        font-size: 1.6rem;
    }

    .admin-tx-actions {
        width: 100%;
        display: flex;
    }

    .admin-tx-actions button {
        flex: 1 1;
        justify-content: center;
        padding: 0.75rem;
        font-size: 0.95rem;
    }

    .wallet-controls {
        flex-direction: column;
        align-items: stretch;
    }

    .wallet-tabs {
        width: 100%;
        flex-direction: column;
    }
}


/* Clean replacements for inline styles */
.no-border {
    border: none !important;
}

.empty-wallet-icon {
    margin-bottom: 1rem;
    opacity: 0.3;
}

.tx-date {
    margin: 0.2rem 0 0 0;
    color: #64748b;
    font-size: 0.95rem;
}

.tx-reason {
    margin: 0 !important;
    font-style: italic;
    color: #94a3b8;
    font-size: 0.9rem;
}

.tx-inline-arrow {
    color: #94a3b8;
    margin: 0 4px;
    vertical-align: middle;
}

.full-width-center {
    width: 100%;
    justify-content: center;
}


/* =========================================
   === COMPACT HISTORY ROWS UI ===
   ========================================= */

.compact-history-wrapper {
    display: flex;
    flex-direction: column;
}

.compact-history-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 0;
    border-bottom: 1px solid #f1f5f9;
    transition: background 0.2s ease;
}

.compact-history-row:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.compact-history-row:hover {
    background: #f8fafc;
    border-radius: 8px;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

.chr-left {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex: 1 1;
    min-width: 0;
}

.chr-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
}

.chr-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.chr-title {
    font-weight: 700;
    color: #1e293b;
    font-size: 0.95rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.chr-arrow {
    color: #94a3b8;
    margin: 0 4px;
    vertical-align: middle;
}

.chr-meta {
    font-size: 0.8rem;
    color: #64748b;
    margin-top: 0.15rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.chr-reason {
    font-style: italic;
    color: #94a3b8;
    margin-left: 0.25rem;
}

.chr-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    flex-shrink: 0;
    margin-left: 1rem;
}

.chr-amount {
    font-weight: 800;
    font-size: 1.1rem;
    line-height: 1;
    margin-bottom: 0.35rem;
}

/* Base styles for the main container */
.admin-tx-list-container {
    background: white;
    padding: 1.5rem;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    min-height: 400px;
}

/* Adjust mobile layout to keep the rows compact but readable */
@media (max-width: 768px) {
    .compact-history-row {
        align-items: flex-start;
        padding: 0.85rem 0;
    }

    .chr-title {
        white-space: normal;
        line-height: 1.3;
    }

    .chr-meta {
        white-space: normal;
        line-height: 1.4;
    }

    .chr-reason {
        display: block;
        margin-left: 0;
        margin-top: 0.25rem;
    }

    .chr-amount {
        font-size: 1.05rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminCashTransfers.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,sDAAsD;AACtD;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8CAA8C;IAC9C,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,yBAAyB;AACzB;;IAEI,oCAAoC;IACpC;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,cAAc;QACd,oBAAoB;QACpB,6BAA6B;QAC7B,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,SAAO;QACP,uBAAuB;QACvB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,sBAAsB;IAC1B;AACJ;;;AAGA,yCAAyC;AACzC;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;;AAGA;;8CAE8C;;AAE9C;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;AAC1B;;AAEA,uCAAuC;AACvC;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,+DAA+D;AAC/D;IACI;QACI,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["/* Container for the list */\n.admin-tx-list-container {\n    background: white;\n    padding: 1.5rem;\n    border-radius: 16px;\n    border: 1px solid #e2e8f0;\n    min-height: 400px;\n}\n\n/* Container for the right side of the transfer card */\n.admin-tx-right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.6rem;\n    flex-shrink: 0;\n    margin-left: 1rem;\n}\n\n/* The Amount */\n.admin-tx-amount {\n    margin: 0;\n    font-size: 1.4rem;\n    font-weight: 800;\n    line-height: 1;\n}\n\n/* Button Wrapper */\n.admin-tx-actions {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n}\n\n/* Sleeker Action Buttons for the Card */\n.admin-tx-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.35rem;\n    padding: 0.5rem 0.85rem;\n    border-radius: 8px;\n    font-weight: 700;\n    font-size: 0.85rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: 1px solid transparent;\n}\n\n.btn-reject-tx {\n    background: #fef2f2;\n    color: #dc2626;\n    border-color: #fecaca;\n}\n\n.btn-reject-tx:hover {\n    background: #fee2e2;\n    border-color: #ef4444;\n}\n\n.btn-confirm-tx {\n    background: #ecfdf5;\n    color: #059669;\n    border-color: #a7f3d0;\n}\n\n.btn-confirm-tx:hover {\n    background: #d1fae5;\n    border-color: #10b981;\n}\n\n/* === NEW: TABS UI === */\n.wallet-controls {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    background: white;\n    padding: 1rem;\n    border-radius: 12px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n    border: 1px solid #e2e8f0;\n    margin-bottom: 2rem;\n}\n\n.wallet-tabs {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.w-tab {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: transparent;\n    border: none;\n    color: #64748b;\n    padding: 0.75rem 1.25rem;\n    border-radius: 8px;\n    font-weight: 600;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: 0.2s;\n}\n\n.w-tab:hover {\n    background: #f1f5f9;\n    color: #1e293b;\n}\n\n.w-tab.active {\n    background: #1e293b;\n    color: white;\n}\n\n/* === NEW: HISTORY STATUS BADGES === */\n.w-status {\n    font-size: 0.75rem;\n    font-weight: 700;\n    padding: 0.25rem 0.65rem;\n    border-radius: 6px;\n    text-transform: uppercase;\n    display: inline-block;\n    margin-top: 0.25rem;\n}\n\n.s-green {\n    background: #dcfce7;\n    color: #15803d;\n}\n\n.s-red {\n    background: #fee2e2;\n    color: #b91c1c;\n}\n\n.s-gray {\n    background: #f1f5f9;\n    color: #64748b;\n}\n\n.s-yellow {\n    background: #fef9c3;\n    color: #b45309;\n}\n\n.bg-blue-light {\n    background: #eff6ff;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n/* Responsive Overrides */\n@media (max-width: 768px) {\n\n    /* Stack the entire card on mobile */\n    .admin-employees-container .elder-list-card {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 1rem;\n    }\n\n    .admin-tx-right {\n        margin-left: 0;\n        align-items: stretch;\n        border-top: 1px solid #f1f5f9;\n        padding-top: 1rem;\n    }\n\n    .admin-tx-amount {\n        text-align: left;\n        margin-bottom: 0.5rem;\n        font-size: 1.6rem;\n    }\n\n    .admin-tx-actions {\n        width: 100%;\n        display: flex;\n    }\n\n    .admin-tx-actions button {\n        flex: 1;\n        justify-content: center;\n        padding: 0.75rem;\n        font-size: 0.95rem;\n    }\n\n    .wallet-controls {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .wallet-tabs {\n        width: 100%;\n        flex-direction: column;\n    }\n}\n\n\n/* Clean replacements for inline styles */\n.no-border {\n    border: none !important;\n}\n\n.empty-wallet-icon {\n    margin-bottom: 1rem;\n    opacity: 0.3;\n}\n\n.tx-date {\n    margin: 0.2rem 0 0 0;\n    color: #64748b;\n    font-size: 0.95rem;\n}\n\n.tx-reason {\n    margin: 0 !important;\n    font-style: italic;\n    color: #94a3b8;\n    font-size: 0.9rem;\n}\n\n.tx-inline-arrow {\n    color: #94a3b8;\n    margin: 0 4px;\n    vertical-align: middle;\n}\n\n.full-width-center {\n    width: 100%;\n    justify-content: center;\n}\n\n\n/* =========================================\n   === COMPACT HISTORY ROWS UI ===\n   ========================================= */\n\n.compact-history-wrapper {\n    display: flex;\n    flex-direction: column;\n}\n\n.compact-history-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.75rem 0;\n    border-bottom: 1px solid #f1f5f9;\n    transition: background 0.2s ease;\n}\n\n.compact-history-row:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n}\n\n.compact-history-row:hover {\n    background: #f8fafc;\n    border-radius: 8px;\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n}\n\n.chr-left {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    flex: 1;\n    min-width: 0;\n}\n\n.chr-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.chr-info {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.chr-title {\n    font-weight: 700;\n    color: #1e293b;\n    font-size: 0.95rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.chr-arrow {\n    color: #94a3b8;\n    margin: 0 4px;\n    vertical-align: middle;\n}\n\n.chr-meta {\n    font-size: 0.8rem;\n    color: #64748b;\n    margin-top: 0.15rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.chr-reason {\n    font-style: italic;\n    color: #94a3b8;\n    margin-left: 0.25rem;\n}\n\n.chr-right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    flex-shrink: 0;\n    margin-left: 1rem;\n}\n\n.chr-amount {\n    font-weight: 800;\n    font-size: 1.1rem;\n    line-height: 1;\n    margin-bottom: 0.35rem;\n}\n\n/* Base styles for the main container */\n.admin-tx-list-container {\n    background: white;\n    padding: 1.5rem;\n    border-radius: 16px;\n    border: 1px solid #e2e8f0;\n    min-height: 400px;\n}\n\n/* Adjust mobile layout to keep the rows compact but readable */\n@media (max-width: 768px) {\n    .compact-history-row {\n        align-items: flex-start;\n        padding: 0.85rem 0;\n    }\n\n    .chr-title {\n        white-space: normal;\n        line-height: 1.3;\n    }\n\n    .chr-meta {\n        white-space: normal;\n        line-height: 1.4;\n    }\n\n    .chr-reason {\n        display: block;\n        margin-left: 0;\n        margin-top: 0.25rem;\n    }\n\n    .chr-amount {\n        font-size: 1.05rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
